<div class="full-screen-container" *ngIf="screen" #fullScreenContainer (click)="zoom($event)">
  <monitor
    [monitor]="screen" [isSelectionEnable]="false" [isFullScreen]="true" [showScreenName]="routeParams.showLabel"
    (viewModeChanged)="viewMode = $event">
  </monitor>
</div>
